"use client";
import React from "react";
import styles from "./PinnedReview.module.css";
import { Review } from "@/app/me/[slug]/Mentor/Mentor.schema";
import Image from "next/image";

export interface PinnedReviewProps {
  review: Review;
  jumpToReviews: () => void;
}

const PinnedReview = ({ review, jumpToReviews }: PinnedReviewProps) => {
  return (
    <div data-testid="pinned_review" className={styles.container}>
      <div className={styles.inner_container}>
        <div className={styles.mentee}>
          <Image
            src={review.reviewer.avatarImage}
            alt={`${review.reviewer.name}'s avatar`}
            width={40}
            height={40}
            className={styles.avatar_image}
          />
          <h3>{review.reviewer.name}</h3>
        </div>
        <p>&ldquo;{review.comment.trim()}&rdquo;</p>
        <button data-testid={"jump_to_reviews"} onClick={jumpToReviews}>
          Jump to reviews
        </button>
      </div>
    </div>
  );
};

export default PinnedReview;
